import React, { useMemo, useState } from 'react';
import { Dialogs, Dialog, TextInput, Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('molten.views.hooks.useResponsiveBreakpoints');
const defaultBreakpoints = breakpoints => {
  if (breakpoints) {
    return breakpoints;
  }
  return [{
    name: 'small',
    size: Config.get('ResponsiveUtility', 'smallBreakpoint', 1024)
  }, {
    name: 'big',
    size: Number.POSITIVE_INFINITY
  }];
};
const createEffect = (setBreakpoint, breakpoints) => {
  return () => {
    const fn = evt => {
      if (evt.ctrlKey && evt.altKey && evt.code === 'KeyR') {
        Dialogs.show({
          id: 'changeResponsiveBreakpoint',
          component: function ChangeResponsiveBreakpointComponent(props) {
            const {
              onClose,
              show
            } = props;
            const [bp, setBp] = useState('big');
            const onOkay = () => {
              const bpObj = breakpoints?.find(b => b.name === bp);
              if (bpObj) {
                setBreakpoint(bpObj);
              }
              onClose();
            };
            const onChange = ({
              value
            }) => {
              setBp(value);
            };
            return /*#__PURE__*/React.createElement(Dialog.Question, {
              show: show,
              onCancel: onClose,
              onOkay: onOkay,
              title: t('title')
            }, /*#__PURE__*/React.createElement(Text, null, t('message')), /*#__PURE__*/React.createElement(TextInput, {
              value: bp,
              onChange: onChange
            }));
          },
          props: {}
        });
      }
    };
    document.addEventListener('keypress', fn);
    return () => document.removeEventListener('keypress', fn);
  };
};
function findBreakPoint(breakpoints, width) {
  return breakpoints?.find(el => el.size > width);
}
export default function useResponsiveBreakpoints(components, props, inputBreakpoints) {
  const breakpoints = useMemo(() => defaultBreakpoints(inputBreakpoints), [inputBreakpoints]);
  const [breakpoint, setBreakpoint] = React.useState(findBreakPoint(breakpoints, window?.innerWidth));
  React.useEffect(createEffect(setBreakpoint, breakpoints), [setBreakpoint, breakpoints]);
  React.useEffect(() => {
    const fn = evt => {
      const current = findBreakPoint(breakpoints, evt.target?.innerWidth);
      if (current !== breakpoint) {
        setBreakpoint(current);
      }
    };
    window.addEventListener('resize', fn);
    return () => {
      window.removeEventListener('resize', fn);
    };
  }, [breakpoint]);
  const Clazz = components[breakpoint?.name];
  return Clazz ? /*#__PURE__*/React.createElement(Clazz, props) : null;
}